export default __webpack_public_path__ + "static/media/settingsLight.6d38586f.svg";